/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file ProteinEnergeticWearView.jsx
 * @author Daniel Aguirre
 * @description ProteinEnergeticWear View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * ProteinEnergeticWear View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function ProteinEnergeticWearView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getProteinEnergeticWear } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'CON presencia',
        classification: 'SI',
        color: styleGuideColors.alertError
      },

      {
        label: 'SIN presencia',
        classification: 'NO',
        color: styleGuideColors.baxterBrandTeal
      },
      {
        label: 'No Registra',
        classification: 'No Registra',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, classification, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === classification
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label: translate(`dashboardStaff.${label}`),
              color,
              cantidad: respElement.cantidad,
              classification
            }
          ];
        }
      });
      setChartData(data);
    } else {
      setChartData([]);
    }
  };

  useEffect(() => {
    setChartData(null);
    getProteinEnergeticWear({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (index) => {
    const { classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/protein-energetic-wear-list/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F26" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.proteinEnergeticWear')}
        dataValues={chartData || []}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
ProteinEnergeticWearView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getProteinEnergeticWear: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default ProteinEnergeticWearView;
